import { render } from "./ForgotPassword.vue?vue&type=template&id=a6ea2362&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=a6ea2362&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__